import React from "react"
import GlobalStyles from "../GlobalStyles"
import Footer from "./Footer/Footer"
import Header from "../components/Header/Header"
import HomeHeader from "../components/Header/HomeHeader"
import Main from "../components/Main"
import useFacilityData from "../hooks/useFacilityData.ts"
import { Helmet } from "react-helmet"
import jsonLdMain from "../scripts/jsonLdMain.ts"
import jsonLdWebsite from "../scripts/jsonLdWebsite.ts"
import { decode } from "js-base64"

const PageLayout: React.FC = ({ currLocation, children }) => {
  const pageData = useFacilityData()

  const info = pageData.sanityFacility.facilityObj
  const metaData = pageData.site.siteMetadata

  const url = `${metaData.siteUrl}/${currLocation}`

  const metaImgId = info.facilityGroundsImage
    ? JSON.parse(decode(info.facilityGroundsImage.asset.source.id))
    : "Priority%20Health%20Facilities/The%20Gardens%20at%20Scranton/Priority-Logo-Icon-Outlined_rsogb9.png"

  const metaImgUrl = `https://res.cloudinary.com/agoraservices/q_auto,f_auto/${metaImgId}`

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "en",
        }}
      >
        <title>{info.facilityName}</title>
        <meta name="title" content={info.facilityName} />
        <meta name="description" content={info.siteContent.initParagraphText} />
        <link rel="canonical" href={url} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={info.facilityName} />
        <meta
          property="og:description"
          content={info.siteContent.initParagraphText}
        />
        <meta property="og:image" itemProp="image" content={metaImgUrl} />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={url} />
        <meta property="twitter:title" content={info.facilityName} />
        <meta
          property="twitter:description"
          content={info.siteContent.initParagraphText}
        />
        <meta property="twitter:image" content={metaImgUrl} />

        <script type="application/ld+json">
          {JSON.stringify(jsonLdMain(info, metaData))}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(jsonLdWebsite(info, metaData))}
        </script>
      </Helmet>
      <GlobalStyles />
      <div id="StickyFooter--body">
        {currLocation === "/" ? (
          <HomeHeader
            info={info}
            metaData={metaData}
            currLocation={currLocation}
          />
        ) : (
          <Header info={info} metaData={metaData} currLocation={currLocation} />
        )}
        <Main>{children}</Main>
      </div>
      <Footer info={info} metaData={metaData} />
    </>
  )
}

export default PageLayout
